// Máscara progressiva de CPF/CNPJ do campo de acesso do Customer
// (.docs/0k - 20-plano-login-cpf-cnpj.md, §7.1).
//
// Só formatação de input — dígito verificador, existência e elegibilidade são
// do backend. Até 11 dígitos é CPF; qualquer letra ou 12+ caracteres é CNPJ,
// o que já cobre o CNPJ alfanumérico da IN RFB nº 2.229/2024 (12 primeiros
// caracteres em [0-9A-Z] + 2 dígitos verificadores — a máscara não valida
// essa última parte, nem precisa).

const CPF_GROUPS = [3, 3, 3, 2];
const CPF_SEPARATORS = [".", ".", "-"];
const CNPJ_GROUPS = [2, 3, 3, 4, 2];
const CNPJ_SEPARATORS = [".", ".", "/", "-"];

// Monta a máscara só até onde há caracteres: o separador entra junto com o
// primeiro caractere do grupo seguinte, nunca "pendurado" no fim.
function applyGroups(chars, groups, separators) {
  let masked = "";
  let cursor = 0;

  groups.forEach((size, index) => {
    if (cursor >= chars.length) return;
    if (index > 0) masked += separators[index - 1];
    masked += chars.slice(cursor, cursor + size);
    cursor += size;
  });

  return masked;
}

// 000.000.000-00 — espera só dígitos (até 11).
export function maskCpf(digits) {
  return applyGroups(digits, CPF_GROUPS, CPF_SEPARATORS);
}

// XX.XXX.XXX/XXXX-XX — espera [0-9A-Z] (até 14).
export function maskCnpj(chars) {
  return applyGroups(chars, CNPJ_GROUPS, CNPJ_SEPARATORS);
}

// Até 11 dígitos é CPF; letra ou 12+ caracteres é CNPJ. Aceita valor colado
// com máscara (os separadores são descartados antes de reaplicar).
export function formatDocument(value) {
  const chars = value.toUpperCase().replace(/[^0-9A-Z]/g, "").slice(0, 14);
  return chars.length <= 11 && /^\d*$/.test(chars) ? maskCpf(chars) : maskCnpj(chars);
}
